import React, { useState } from 'react'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

// import 'react-pdf/dist/esm/Page/TextLayer';

// /react-pdf/dist/esm/Page/AnnotationLayer.css
// react-pdf/dist/esm/Page/TextLayer.css
const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: false,
    standardFontDataUrl: 'standard_fonts/',
};
export const PDFViewer = (downloadedFile={}) => {
    const [numPages, setNumPages] = useState(null);
    const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
        console.log("Document Loaded")
        setNumPages(nextNumPages);
    }
    return <div>
        <Document 
        renderTextLayer={false} renderAnnotationLayer={false}
        onLoadError={(e) => {
            console.log("Document load error ", e);
        }}
            file={downloadedFile.file}
            onLoadSuccess={onDocumentLoadSuccess} options={options}>
            {Array.from(new Array(numPages), (el, index) => (
                <Page
                customTextRenderer={(layer)=>{
                    console.log(layer);
                }}
                 width={826} key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
        </Document>
    </div>
}